module.exports = __webpack_public_path__ + "static/media/a3.5891a53a.png";